import React from 'react';

const StockManagement = () => {
  return (
    <div className="stock-management">
      <div className="page-header">
        <h2>Stok Yönetimi</h2>
        <p>Stok hareketlerini takip edin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default StockManagement; 